import React from 'react';
import { Icon } from './Icon.js';
export const IconLoader6 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 12C22 6.47715 17.5228 2 12 2", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLoader6.js.map